import React from "react";
import UserRow from "./UserRow";

const UserTable = ({ users, onEdit, onPassword }) => {
    return (
        <div className="w-full overflow-x-auto border border-gray-200 bg-white">
            <table className="w-full table-fixed border border-gray-300 border-collapse text-sm">
                <thead className="">
                    <tr className="border border-gray-300">
                        <th className="px-1 py-4 text-left border border-gray-300 w-[70px]">UserID</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[150px]">Name</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[250px]">Email</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[110px]">Phone</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[70px]">Role</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[70px]">Status</th>
                        <th className="px-1 py-4 text-left border border-gray-300 w-[200px]">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {users.map((user) => (
                        <UserRow
                            key={user.id}
                            user={user}
                            onEdit={onEdit}
                            onPassword={onPassword}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserTable;